import React, { createContext, useState, useContext, useEffect } from 'react';
import { canMakeRequest, recordRequest, recordAdView } from '../services/usageTracker';
import AdModal from '../components/AdModal';

const UsageContext = createContext();

export function UsageProvider({ children }) {
  const [usageStatus, setUsageStatus] = useState(canMakeRequest());
  const [showAdModal, setShowAdModal] = useState(false);

  // Update status every second during cooldown
  useEffect(() => {
    if (!usageStatus.allowed && usageStatus.reason === 'cooldown') {
      const timer = setInterval(() => {
        const newStatus = canMakeRequest();
        setUsageStatus(newStatus);
        if (newStatus.allowed) {
          clearInterval(timer);
        }
      }, 1000); // Check every second for smoother updates
      
      return () => clearInterval(timer);
    }
  }, [usageStatus.allowed, usageStatus.reason]);

  const showAd = () => {
    setShowAdModal(true);
  };

  const handleAdLoaded = () => {
    const newStatus = recordAdView();
    setUsageStatus(newStatus);
    handleCloseModal();
  };

  const handleCloseModal = () => {
    setShowAdModal(false);
  };

  const checkAndRecordRequest = () => {
    const status = canMakeRequest();
    if (!status.allowed) {
      setUsageStatus(status);
      return false;
    }
    
    recordRequest();
    const newStatus = canMakeRequest();
    setUsageStatus(newStatus);
    return true;
  };

  return (
    <UsageContext.Provider value={{ usageStatus, showAd, checkAndRecordRequest }}>
      {children}
      <AdModal 
        isOpen={showAdModal} 
        onClose={handleCloseModal}
        onAdLoaded={handleAdLoaded}
      />
    </UsageContext.Provider>
  );
}

export function useUsage() {
  const context = useContext(UsageContext);
  if (!context) {
    throw new Error('useUsage must be used within a UsageProvider');
  }
  return context;
}
